package com.castly.admin.ui

/**
 * Podcast content classification types (frontend).
 * Must match backend enum values.
 */
enum class PodcastType {
    PODCAST,
    RADIO_SHOW,
    QURAAN,
    TV_SERIES,
    NEWS,
    DOCUMENTARY,
    COURSE,
    BOOKS;

    val displayName: String
        get() = when (this) {
            PODCAST -> "Podcast"
            RADIO_SHOW -> "Radio Show"
            QURAAN -> "Quraan"
            TV_SERIES -> "TV Series"
            NEWS -> "News"
            DOCUMENTARY -> "Documentary"
            COURSE -> "Course"
            BOOKS -> "Books"
        }

    companion object {
        fun fromString(value: String?): PodcastType {
            if (value == null) return PODCAST
            return try {
                valueOf(value.uppercase())
            } catch (e: IllegalArgumentException) {
                PODCAST // Default fallback
            }
        }
    }
}
